import { Component } from '@angular/core';
import { ModalContent, ModalRef } from '../../../../modal/modal-ref';
import { TranslatePipe } from '../../../../services/translation/translate.pipe';
import { BtnComponent } from '../../../../shared/components/btn/btn.component';


@Component({
    selector: 'app-text-alert',
    templateUrl: './text-alert.component.html',
    styleUrls: ['./text-alert.component.scss'],
    imports: [BtnComponent, TranslatePipe]
})
export class TextAlertComponent implements ModalContent {

  public modal: ModalRef;

  constructor() {
  }

  get data(): any {
    return this.modal.options.data;
  }

}
